import script from "./factory.vue?vue&type=script&setup=true&lang=js"
export * from "./factory.vue?vue&type=script&setup=true&lang=js"

import "./factory.vue?vue&type=style&index=0&id=9d73f726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d73f726"]])

export default __exports__